import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const ReportsOutstanding = () => {
  const generateSampleData = (count = 80) => {
    const riskLevels = ['Low', 'Medium', 'High'];
    const regions = ['North', 'South', 'East', 'West', 'Central'];

    return Array.from({ length: count }, (_, index) => {
      const outstanding = Math.floor(Math.random() * 50000) + 5000;
      const creditLimit = Math.floor(Math.random() * 70000) + 30000;
      const totalCredit = creditLimit + Math.floor(Math.random() * 60000);
      const totalDebit = totalCredit - outstanding;
      const ageingDays = Math.floor(Math.random() * 45) + 1;
      const utilisation = ((outstanding / creditLimit) * 100).toFixed(1);
      const risk = outstanding / creditLimit > 0.6 ? 'High' : outstanding / creditLimit > 0.4 ? 'Medium' : 'Low';

      return {
        requestId: `OUT${String(index + 1).padStart(6, '0')}`,
        distributorCode: `DIS${String(Math.floor(Math.random() * 9000) + 1000)}`,
        distributorName: `Distributor ${Math.floor(Math.random() * 150) + 1}`,
        region: regions[Math.floor(Math.random() * regions.length)],
        retailersMapped: Math.floor(Math.random() * 220) + 25,
        lastSettlement: new Date(2025, Math.floor(Math.random() * 10), Math.floor(Math.random() * 28) + 1)
          .toISOString()
          .split('T')[0],
        outstanding,
        totalCredit,
        totalDebit,
        creditLimit,
        utilisation,
        ageingDays,
        riskLevel: risk,
        remarks:
          risk === 'High'
            ? 'Escalated to finance desk'
            : risk === 'Medium'
            ? 'Remittance reminder shared'
            : 'On schedule',
      };
    });
  };

  const [data] = useState(generateSampleData(90));

  const columns = [
    { key: 'riskLevel', label: 'Risk Level' },
    { key: 'requestId', label: 'Record ID' },
    { key: 'distributorCode', label: 'Distributor Code' },
    { key: 'distributorName', label: 'Distributor Name' },
    { key: 'region', label: 'Region' },
    { key: 'retailersMapped', label: 'Retailers Mapped' },
    { key: 'lastSettlement', label: 'Last Settlement' },
    { key: 'totalCredit', label: 'Total Credit (₹)' },
    { key: 'totalDebit', label: 'Total Debit (₹)' },
    { key: 'outstanding', label: 'Outstanding (₹)' },
    { key: 'creditLimit', label: 'Credit Limit (₹)' },
    { key: 'utilisation', label: 'Utilisation %' },
    { key: 'ageingDays', label: 'Ageing (Days)' },
    { key: 'remarks', label: 'Remarks' },
  ];

  return (
    <Container fluid>
      <ReportsTable
        data={data}
        reportType="SuperDistributor_Outstanding"
        columns={columns}
        title="Outstanding Reports"
      />
    </Container>
  );
};

export default ReportsOutstanding;

